module.exports = __webpack_public_path__ + "static/media/outline.29f95724.svg";